import dayjs from "dayjs";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { CustomDragLayer, DraggableOrderCard } from "@web-app/components";
import { Order } from "@web-app/types";

import { ScrollableContainer } from "./ScrollableContainer";

interface OrderListProps {
  durations: number[];
  editRouteOrderIds: string[];
  moveOrder: (dragIndex: number, hoverIndex: number) => void;
  orders: Map<string, Order> | undefined;
  removeOrder: (orderId: string) => void;
  routedOrdersDraftEstimatedEta?: Map<string, Date | null>;
}

export function OrderList({
  editRouteOrderIds,
  orders,
  routedOrdersDraftEstimatedEta = new Map(),
  durations,
  moveOrder,
  removeOrder,
}: OrderListProps) {
  if (editRouteOrderIds.length === 0) return null;

  return (
    <DndProvider backend={HTML5Backend}>
      <CustomDragLayer />
      <ScrollableContainer>
        {editRouteOrderIds.map((orderId, index) => {
          const order = orders?.get(orderId);
          if (!order) {
            return null;
          }

          if (
            order.status !== "COMPLETE" &&
            order.status !== "CANCELLED" &&
            order.status !== "FAILED" &&
            durations.length > 0
          ) {
            if (index === 0) {
              order.estimatedEtaDateTime = new Date(
                order.scheduledStartDateTime,
              );
            } else {
              const currentOrderDuration = durations[index - 1];
              const startDateTime = new Date(order.scheduledStartDateTime);
              const newDateTime = dayjs(startDateTime)
                .add(currentOrderDuration, "second")
                .toDate();
              order.estimatedEtaDateTime = newDateTime;
            }
          }

          return (
            <DraggableOrderCard
              key={orderId}
              order={order}
              routedOrdersDraftEstimatedETA={routedOrdersDraftEstimatedEta}
              index={index}
              moveOrder={moveOrder}
              orderNumber={index}
              removeOrder={removeOrder}
            />
          );
        })}
      </ScrollableContainer>
    </DndProvider>
  );
}
